import { useOffline } from "@/hooks/use-offline";
import { WifiOff } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";

export function OfflineIndicator() {
  const isOffline = useOffline();
  const isMobile = useIsMobile();

  if (!isOffline || !isMobile) return null;

  return (
    <div className="fixed top-14 left-0 right-0 z-50 bg-warning text-warning-foreground px-4 py-2 flex items-center justify-center gap-2 text-sm md:hidden">
      <WifiOff className="h-4 w-4" />
      <span>You're offline. Viewing cached content.</span>
    </div>
  );
}
